import type {
  AddressBasedTemplatePageConfig,
  CheckArgumentsTemplateListConfig,
} from "../check-arguments-templates-shared";

export const INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_PAGE_CONFIG: AddressBasedTemplatePageConfig =
  {
    apiPathPrefix: "international-criminal-database",
    settingsPathPrefix: "international-criminal-database-templates",
    templateLabel: (t) => t("International criminal database"),
    testIdPrefix: "international-criminal-database-template",
    // NOTE(INTCRIMDB): matches the backend's 60-month lookback default rather
    // than the shared 10-year default.
    defaultLookbackYears: 5,
    showMaximumPrice: true,
  };

export const INTERNATIONAL_CRIMINAL_DATABASE_TEMPLATE_LIST_CONFIG: CheckArgumentsTemplateListConfig =
  {
    listApiPath:
      "/api/internal/client-portal/check-arguments-templates/international-criminal-database/",
    settingsPathPrefix: "international-criminal-database-templates",
    pageTitle: (t) => t("International criminal database"),
    testIdPrefix: "international-criminal-database-template",
    apiPathPrefix: "international-criminal-database",
    filterBarTestId: "international-criminal-database",
  };
